import { combineReducers } from 'redux';
import Invoice from './r.invoice'
import RuleText from './r.ruletext'

const appReducer = combineReducers({
    Invoice,
    RuleText
})

const rootReducer = (state, action) => {
    if (action.type === 'RESET_STORE') {
        console.log("reset");
        state = undefined;
    }
    return appReducer(state, action);
}

export default rootReducer;